module.exports = __webpack_public_path__ + "img/img-5.fcbd82b4.png";